import { useEffect } from 'react';
import { useLocation } from 'react-router';

const useStructuredData = (data: unknown) => {
  const location = useLocation();

  useEffect(() => {
    const scriptElement = document.createElement('script');
    scriptElement.type = 'application/ld+json';
    scriptElement.innerHTML = JSON.stringify(data);

    document.head.appendChild(scriptElement);

    return () => {
      document.head.removeChild(scriptElement);
    };
  }, [location, data]);
};

export default useStructuredData;
